export default "Wisr does not provide car financing for business customers.\n";